import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { components } from "react-select";
import p1 from "../../../../../Assets/images/user.png";

// css
import styles from "./addForm.module.scss";
import { Formik } from "formik";
import addPeerSchema from "./addPeer.schema";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import { GENDER_OPTIONS, MIME_TYPES } from "config/constants";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import { useProgramLookupQuery } from "store/services/utility";
import { cloneDeep } from "lodash";
import { useChatterPeerDetailsQuery, useCreateChatterPeerMutation, useUpdateChatterPeerMutation } from "store/services/chatter/peer";
import { CHATTER_PEER_LIST } from "config/paths";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useNavigate, useParams, Link } from "react-router-dom";
import { successMessageToast } from "helpers/common";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useCreateNoteMutation, useGetNoteQuery } from "store/services/note";
import NotesComponent from "components/shared/FormComponents/NotesComponent";

const ChatterPeerAdd = () => {

  const { id: peerId } = useParams();

  const editMode = !!peerId;
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    firstname: "",
    lastname: "",
    dob: "",
    address: "",
    city_town: "",
    phone: "",
    email: "",
    gender: "",
    emergency_contact_first_name: "",
    emergency_contact_last_name: "",
    emergency_contact_phone: "",
    referring_agency_name: "",
    referring_agency_phone: "",
    status: "active",
    documents: [],
    referring_agency_name: "",
    referring_agency_phone: "",
    note: ""
  });

  // Program List
  const { data: programList } = useProgramLookupQuery();
  const programListOptions = programList?.map(item => ({ value: item.id, label: item.name }))

  const { data: peerDetails, isLoading } = peerId ? useChatterPeerDetailsQuery(peerId) : {};
  const [createPeer, { isLoading: createPeerLoading }] = useCreateChatterPeerMutation();
  const [updatePeer, { isLoading: updatePeerLoading }] = useUpdateChatterPeerMutation();

  // Notes
  const [createNote, { isLoading: createNoteLoading }] = useCreateNoteMutation();
  const { data: noteDetails, getNotesLoading } = useGetNoteQuery({ clientId: peerId, moduleName: "clients-peer" }, { skip: !peerId });

  const handleSubmit = async (payload) => {

    try {

      const values = cloneDeep(payload);

      values.gender = values?.gender?.value || ""
      delete values.note;

      const result = editMode ? await updatePeer({ data: values, peerId }) : await createPeer(values);

      if (result?.error) {
        console.error("Error creating chatter peer", result.error);
      } else {

        if (payload?.note) await createNote({ module: "clients-peer", client_id: result?.data?.data?.id, note: payload?.note })

        successMessageToast(result?.data?.message);
        navigate(CHATTER_PEER_LIST);
      }
    } catch (err) {
      console.error("Error creating chatter peer", err);
    }
  };

  const handleAttachDocument = (name, value, prevValues, setFieldValue) => {
    try {
      let cloneValues = cloneDeep(prevValues);
      cloneValues.push({
        attachment_key: value,
        attachment_name: value,
      })
      setFieldValue(name, cloneValues);
    } catch (err) {
      console.error("Failed to attach document", err);
    }
  };
  useEffect(() => {

    if (!peerId) return;

    setInitialValues({
      ...initialValues,
      firstname: peerDetails?.firstname,
      lastname: peerDetails?.lastname,
      dob: peerDetails?.client_detail?.dob,
      address: peerDetails?.client_detail?.address || "",
      city_town: peerDetails?.client_detail?.city_town,
      phone: peerDetails?.phone,
      email: peerDetails?.email,
      gender: GENDER_OPTIONS.find(item => item.value === peerDetails?.client_detail?.gender) || "",
      emergency_contact_first_name: peerDetails?.client_detail?.emergency_contact_first_name,
      emergency_contact_last_name: peerDetails?.client_detail?.emergency_contact_last_name,
      emergency_contact_phone: peerDetails?.client_detail?.emergency_contact_phone,
      status: peerDetails?.status,
      documents: peerDetails?.reference_letters?.map(resource => ({
        id: resource.id,
        attachment_key: resource.attachment_key,
        attachment_name: resource.attachment_name
      })) || [],
      referring_agency_name: peerDetails?.client_detail?.referring_agency_name || "",
      referring_agency_phone: peerDetails?.client_detail?.referring_agency_phone || ""
    });

  }, [peerDetails]);

  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="pageHead pb-3 d-flex align-items-center">
                <Link
                  className="themeBlue fw-sbold back-to-btn"
                  to="/manage-chatter/chatter-peers/"
                >
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                  </svg> Back
                </Link>
                <h6 className="m-0 fw-bold themeBlue">{editMode ? "Edit Volunteer" : "Add New Volunteer"}</h6>
              </div>
            </Col>
            {
              isLoading || getNotesLoading ? <LoadingIndicator /> :
                <Col lg="12" className="my-2">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={addPeerSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    {({
                      handleSubmit,
                      values,
                      setFieldValue,
                      errors
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <div
                          className="py-3"
                          style={{ borderTop: "1px solid #41a2a84d" }}
                        >
                          <Row>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Last Name
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="lastname"
                                placeholder="e.g Smith"
                                className={`${styles.formControl} form-control`}
                                maxLength={50}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                First Name
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="firstname"
                                placeholder="e.g John"
                                className={`${styles.formControl} form-control`}
                                maxLength={50}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                DOB
                                <RequiredFieldAstrick />
                              </label>
                              <AppDatePicker
                                name="dob"
                                maxDate={new Date()}
                                className={`${styles.formControl} form-control`}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Address
                              </label>
                              <AppInputField
                                type="text"
                                name="address"
                                placeholder="Address"
                                className={`${styles.formControl} form-control`}
                                maxLength={100}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                City/Town
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="city_town"
                                placeholder="Enter City/Town"
                                className={`${styles.formControl} form-control`}
                                maxLength={30}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Phone
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="tel"
                                name="phone"
                                placeholder="e.g. +1 88 9999 887"
                                className={`${styles.formControl} form-control`}
                                maxLength={25}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Email
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="Email"
                                name="email"
                                placeholder="Email"
                                className={`${styles.formControl} form-control`}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Gender
                              </label>
                              <CommonSelect
                                name="gender"
                                placeholder={"Please Select Gender"}
                                option={GENDER_OPTIONS}
                              />
                            </Col>
                          </Row>
                        </div>
                        <div className="py-3">
                          <Row>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Emergency Contact Last Name
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="emergency_contact_last_name"
                                placeholder="Enter Last Name"
                                className={`${styles.formControl} form-control`}
                                maxLength={50}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Emergency Contact First Name
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="emergency_contact_first_name"
                                placeholder="Enter First Name"
                                className={`${styles.formControl} form-control`}
                                maxLength={50}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Emergency Contact Phone
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="emergency_contact_phone"
                                placeholder="e.g. +1 88 9999 887"
                                className={`${styles.formControl} form-control`}
                                maxLength={25}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12" className="my-2">
                              {/* <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0"
                              >
                                Notes
                              </label> */}
                              {editMode ? <NotesComponent
                                notes={noteDetails}
                                className={`${styles.formControl} form-control`}
                                module={"clients-peer"}
                                client_id={peerId}
                              /> : <AppInputField
                                type="text"
                                fieldType={"textarea"}
                                name="note"
                                placeholder=""
                                className={`${styles.formControl} form-control`}
                                maxLength={500}
                              />}
                            </Col>
                          </Row>
                          <Row>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0"
                              >
                                Attach Registration form
                              </label>
                              <AppFileUploadField
                                name="documents"
                                acl={"private"}
                                accept="application/pdf"
                                allowedTypes={[MIME_TYPES.pdf]}
                                className={`${styles.formControl} form-control`}
                                onChange={(name, value) => {
                                  handleAttachDocument(name, value, values?.documents, setFieldValue);
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                        <Row className="mt-4">
                          <Col className="my-2" lg="12">
                            <div
                              className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                              style={{ borderTop: "1px solid #41a2a84d" }}
                            >
                              <Button
                                className="d-flex align-items-center justify-content-center commonBtn"
                                type="submit"
                                disabled={createPeerLoading || updatePeerLoading || createNoteLoading}
                              >
                                {createPeerLoading || updatePeerLoading || createNoteLoading ? <LoadingIndicator inline /> : "Save"}
                              </Button>
                              <Button
                                className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                                type="button"
                                onClick={() => navigate(CHATTER_PEER_LIST)}
                              >
                                Cancel
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                </Col>
            }
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChatterPeerAdd;
